export const commonFields = [
  { name: "document_type", label: "Document Type" },
  { name: "document_number", label: "Document Number/ID" },
  { name: "owner_name", label: "Owner Name" },
  { name: "remarks", label: "Remarks/Description" },
  { name: "address", label: "Address" },
];

export default commonFields;
